import FuelSelect from "./fuel-select";
export default FuelSelect;